import { BlockUIDesignTokens } from '../../../../types/blockui';

export default {
    root: {
        borderRadius: '{content.border.radius}'
    }
} as BlockUIDesignTokens;
